/** サイドバーの開閉と同じ速さ・緩急。サイドバーと同時に動かす要素はこれを使う。 */
export const SIDEBAR_TRANSITION_TIMING = "0.2s cubic-bezier(0.4, 0, 0.2, 1)";

export const DASHBOARD_MAIN_CONTENT_TRANSITION = `margin-left ${SIDEBAR_TRANSITION_TIMING}`;

interface ResolveInitialSidebarWidthParams {
  viewportWidth: number;
  smBreakpoint: number;
  lgBreakpoint: number;
  cssSidebarWidth: string;
}

export const resolveInitialSidebarWidth = ({
  viewportWidth,
  smBreakpoint,
  lgBreakpoint,
  cssSidebarWidth,
}: ResolveInitialSidebarWidthParams): number => {
  if (viewportWidth < smBreakpoint) return 0;
  if (viewportWidth < lgBreakpoint) return 60;

  const currentCssWidth = Number.parseFloat(cssSidebarWidth);
  return Number.isFinite(currentCssWidth) ? currentCssWidth : 210;
};
